import {Controller} from "@/controllers/Controller";

/**
 * Controller for reception API (ms-purchase) : marchandises livrées par un fournisseur
 */
export class ReceptionController extends Controller {

    static getByPurchase(purchaseId) {
        return this.requestBuilder("GET", `/purchase/receptions/by-purchase/${purchaseId}`, true);
    }

    static post(body) {
        return this.requestBuilder("POST", `/purchase/receptions`, true, body);
    }

    static patch(id, body) {
        return this.requestBuilder("PATCH", `/purchase/receptions/${id}`, true, body);
    }

    static delete(id) {
        return this.requestBuilder("PATCH", `/purchase/receptions/deactivate/${id}`, true);
    }
}
